import React from 'react';

function SectionCard({ title, actions, children, maxWidth = 960 }) {
  return (
    <div className="card bg-dark text-light border-secondary w-100 mb-4" style={{ maxWidth }}>
      <div className="card-header d-flex align-items-center justify-content-between border-secondary">
        <h3 className="h5 m-0">{title}</h3>
        {actions && <div className="d-flex gap-2">{actions}</div>}
      </div>
      <div className="card-body text-start">
        {children}
      </div>
    </div>
  );
}

export default SectionCard;
